import api, { Pagination } from '..'

export class DispatchingCreditService {
  static async findAll(
    productId: string,
    pagination: Pagination,
    organizationId?: string
  ) {
    const response = organizationId
      ? await api.get(
          `/dispatching-credits?productId=${productId}&organizationId=${organizationId}&populate=creditLine,transaction,createdBy,beneficiary&page=${pagination.page}&perPage=${pagination.perPage}`
        )
      : await api.get(
          `/dispatching-credits?productId=${productId}&populate=creditLine,transaction,createdBy,beneficiary&page=${pagination.page}&perPage=${pagination.perPage}`
        )
    const { count, result } = response.data
    return {
      count,
      result: result.map((it: any) => ({
        ...it,
        fullname: `${it.createdBy.lastname} ${it.createdBy.firstname}`
      }))
    }
  }
}
